import React from 'react';

import Plasticfliptop from './Plasticfliptop';
import Injectionmakesplastic from './Injectionmakesplastic';

const Howplasticflipt = () => {
    return (
        <div>
         <Plasticfliptop />
            <Injectionmakesplastic />
        </div>
    );
};

export default Howplasticflipt;
